/**
 * Template tags — client-side normalization to `string[]`.
 *
 * The API serializes tags as a real array (src/lib/templates/tags.ts), but
 * the `templates.tags` column historically leaked through as a raw
 * JSON-encoded string — `'["welcome","onboarding"]'` — which crashed any
 * component that called `.map`/`.join` on it (#821/#824 blank Call Scripts
 * cards + blank edit modal). Keep this defensive normalizer at every
 * consumption site so a stale cache entry or legacy row can never take the
 * grid down again.
 */

export function tagsToArray(raw: string[] | string | null | undefined): string[] {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((t) => String(t).trim()).filter(Boolean);
  try {
    const parsed: unknown = JSON.parse(raw);
    if (Array.isArray(parsed)) {
      return parsed.map((t) => String(t).trim()).filter(Boolean);
    }
  } catch {
    // fall through
  }
  return String(raw)
    .split(/[,|]/)
    .map((s) => s.trim())
    .filter(Boolean);
}
